import { DatePipe } from '@angular/common';
import { Component, inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogConfig } from '@angular/material/dialog';
import { ApiService } from '@portal-core/auth/services/api.service';
import { StatusIncidentStatus } from '@portal-core/status-incidents/enums/status-incident-status.enum';
import { StatusIncidentUpdate } from '@portal-core/status-incidents/models/status-incident-update.model';
import { StatusIncident } from '@portal-core/status-incidents/models/status-incident.model';
import { incidentEndAt, incidentStartAt, typeLabel } from '@portal-core/status-incidents/util/status-incident.util';
import { sortStatusIncidentUpdates } from '@portal-core/status-incidents/util/status-incident-updates.util';
import { NgFor, NgIf } from '@angular/common';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { StartCasePipe } from '@portal-core/general/pipes/start-case/start-case.pipe';

export interface StatusIncidentDialogData {
  incident: StatusIncident;
}

@Component({
  selector: 'mc-status-incident-dialog',
  templateUrl: './status-incident-dialog.component.html',
  styleUrls: ['./status-incident-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [MatDialogTitle, MatIconButton, MatIcon, MatDialogClose, MatDialogContent, NgFor, NgIf, MatDialogActions, MatButton, StartCasePipe, DatePipe],
  providers: [DatePipe]
})
export class StatusIncidentDialogComponent implements OnInit {
  private readonly data = inject<StatusIncidentDialogData>(MAT_DIALOG_DATA);
  private readonly datePipe = inject(DatePipe);
  protected readonly apiService = inject(ApiService);

  static DialogConfig: MatDialogConfig = {
    width: '45rem',
    height: '55rem',
  };

  incident: StatusIncident;
  title: string;
  sortedUpdates: StatusIncidentUpdate[];
  StatusIncidentStatus = StatusIncidentStatus;


  ngOnInit() {
    this.incident = this.data.incident;
    this.sortedUpdates = sortStatusIncidentUpdates(this.incident?.Updates);
    const label = typeLabel(this.incident.Type);
    const formattedDate = this.datePipe.transform(incidentStartAt(this.incident), 'MMMM d, y \'at\' h:mm a');
    this.title = `${label} on ${formattedDate}`;
    const incidentEnd = incidentEndAt(this.incident);
    if (incidentEnd) {
      const formattedEndDate = this.datePipe.transform(incidentEnd, 'MMMM d, y \'at\' h:mm a');
      this.title += `. Expected to end by ${formattedEndDate}`;
    }
  }
}
